<template>
	<AppVMenu width="200" min-width="200" bottom left offset-y content-class="dropdown-menu-container">
		<template v-slot:activator="{ on }">
			<AnemicButton
				v-on="on"
				@click="(e) => e.preventDefault()"
				width="22"
				height="22"
				icon
				fab
				x-small
				class="flex-centerize menu-button mx-2 mt-2"
			>
				<AppIcon name="three-dot-menu" width="13" class="menu-icon" />
			</AnemicButton>
		</template>
		<v-list :disabled="disabled">
			<v-list-item class="item-container" @click="renameTemplate" v-if="!isPublicTemplate">
				<v-list-item-title>
					<span style="color: #3e495a; font-size: 14px; font-weight: 400"> Rename </span>
				</v-list-item-title>
			</v-list-item>
			<v-list-item class="item-container" @click="duplicateTemplate">
				<v-list-item-title>
					<span style="color: #3e495a; font-size: 14px; font-weight: 400"> {{ duplicateText }} </span>
				</v-list-item-title>
			</v-list-item>
			<v-list-item class="item-container" @click="onDeleteTemplateClicked" v-if="!isPublicTemplate">
				<v-list-item-title>
					<span style="color: #3e495a; font-size: 14px; font-weight: 400"> Delete </span>
				</v-list-item-title>
			</v-list-item>
			<v-list-item class="item-container" @click="onSetAsDefaultClicked" v-if="!isPublicTemplate">
				<v-list-item-title>
					<span style="color: #3e495a; font-size: 14px; font-weight: 400"> Set as default template </span>
				</v-list-item-title>
			</v-list-item>
		</v-list>
	</AppVMenu>
</template>
<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { fetchWorkflowsRelatedToTemplateId } from '@/store/modules/transactionalEmailTemplate/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'ActionsButton',
	props: { template: { type: Object }, disabled: { type: Boolean, default: false } },
	methods: {
		...mapActionsShorthand({ fetchWorkflowsRelatedToTemplateId }),
		renameTemplate() {
			this.$emit('rename-template', this.template);
		},
		duplicateTemplate() {
			this.$emit('duplicate-template', { id: this.template.id, isPublic: this.isPublicTemplate });
		},
		async onDeleteTemplateClicked() {
			const usedInWorkflowsInfo = await this.fetchWorkflowsRelatedToTemplateId({ templateId: this.template.id });
			if (usedInWorkflowsInfo.count) {
				await AppDialogManagerService.openCantDeleteUsedEmailTemplateDialog({ usedInWorkflowsInfo });
				return;
			}
			this.$emit('delete-template', this.template.id);
		},
		onSetAsDefaultClicked() {
			this.$emit('set-default-template', this.template.id);
		},
	},
	computed: {
		isPublicTemplate() {
			return this.template?.is_public;
		},
		duplicateText() {
			return this.template?.is_public ? 'Create usable copy' : 'Duplicate';
		},
	},
};
</script>
<style scoped lang="scss"></style>
